declare const Cookiebot: { renew: () => void };

export default class CookiebotHandler {
    constructor() {
        document.querySelectorAll("[data-cookiebot-renew]").forEach((element) => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                if (typeof Cookiebot !== "undefined") {
                    Cookiebot.renew();
                }
            });
        });
    }
}
